export var TaskQueryKey;
(function (TaskQueryKey) {
    TaskQueryKey["PlannedTasks"] = "PlannedTasks";
    TaskQueryKey["Remark"] = "PlannedTasks/remark";
    TaskQueryKey["TaskAttachments"] = "PlannedTasks/attachments";
    TaskQueryKey["AssignedUser"] = "AssignedUser";
    TaskQueryKey["KPI"] = "PlannedTasks/kpi";
    TaskQueryKey["TaskTemplates"] = "Task/Templates";
    TaskQueryKey["SubtaskTemplates"] = "Subtask/Templates";
    TaskQueryKey["ResourceTags"] = "Resource/Tags";
    TaskQueryKey["MyTeams"] = "Teams/MyTeams";
    TaskQueryKey["TaskPeriodicity"] = "Task/Periodicity";
    TaskQueryKey["AssignmentTemplates"] = "Assignment/Templates";
    TaskQueryKey["TaskTags"] = "Task/Tags";
    TaskQueryKey["TaskDocumentation"] = "Task/Documentation";
    TaskQueryKey["TaskWidgetKPI"] = "PlannedTasks/kpi/widget";
    TaskQueryKey["WeekPlanner"] = "WeekPlanner";
    TaskQueryKey["WeekPlannerCapacity"] = "WeekPlanner/Capacity";
    TaskQueryKey["WeekPlannerExternalEvents"] = "WeekPlanner/ExternalEvents";
    TaskQueryKey["WeekPlannerUnplannedTasks"] = "WeekPlanner/UnplannedTasks";
})(TaskQueryKey || (TaskQueryKey = {}));
